export default __webpack_public_path__ + "static/payroll-for-teams-easy-salary-cf263b8085e533405690d1be2ef5ee29.png";